/**
 * Danh mục lý do ĐỔI GÁN — bản sao của `orderdispatch/overridereason.go`
 * (QĐ 0209, CEO chốt 1a ngày 25/09/2026).
 *
 * Vì sao chép sang đây thay vì gọi một cửa danh mục: sáu dòng cố định, đổi
 * rất hiếm, mà thêm một lượt gọi mạng để vẽ một ô chọn là làm hộp thoại chớp
 * trắng mỗi lần mở. Đổi bên nào cũng phải đổi bên kia —
 * `overrideReasons.test.ts` ghim đúng sáu mã và đúng hai mã có lỗi, nên lệch
 * là bài kiểm đỏ chứ không phải người dùng phát hiện.
 *
 * 🔴 Thứ tự có chủ đích: bốn lý do KHÔNG lỗi đứng trước. Danh sách mở đầu
 * bằng hai dòng buộc tội là mời người bấm chọn bừa dòng đầu tiên.
 */
/**
 * Mã lý do — kiểu LITERAL chứ không phải `string`, để hợp đồng sinh từ
 * openapi bắt được ngay khi một mã ở đây không còn nằm trong enum của máy
 * chủ. Khai `string` là lệch bên nào cũng lọt tới lúc chạy.
 */
export type OverrideReasonCode =
  | "prev_shoot_running_late"
  | "customer_request"
  | "staff_on_leave"
  | "rebalance"
  | "staff_no_show"
  | "staff_personal";

export type OverrideReason = {
  code: OverrideReasonCode;
  label: string;
  /** Có ghi sổ lỗi cho người bị đổi hay không. */
  fault: boolean;
};

export const OVERRIDE_REASONS: readonly OverrideReason[] = [
  { code: "prev_shoot_running_late", label: "Ca trước chưa chụp xong", fault: false },
  { code: "customer_request", label: "Khách yêu cầu người khác", fault: false },
  { code: "staff_on_leave", label: "Thợ có phép / báo nghỉ", fault: false },
  { code: "rebalance", label: "Điều phối lại cho hợp lý", fault: false },
  { code: "staff_no_show", label: "Thợ chưa có mặt tại tiệm", fault: true },
  { code: "staff_personal", label: "Thợ bận việc riêng, không nhận", fault: true },
];

export function overrideReasonOf(code: string): OverrideReason | undefined {
  return OVERRIDE_REASONS.find((r) => r.code === code);
}

/** Mã hợp lệ hay không — thu `string` của ô chọn về kiểu literal. */
export function isOverrideReasonCode(code: string): code is OverrideReasonCode {
  return OVERRIDE_REASONS.some((r) => r.code === code);
}
